import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import SouthAmericaIcon from '@mui/icons-material/SouthAmerica';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LanguageIcon from '@mui/icons-material/Language';
import SettingsIcon from '@mui/icons-material/Settings';
import HomeIcon from '@mui/icons-material/Home';
//import LanOutlinedIcon  from '@mui/icons-material/LanOutlined';
import {getCountryCode} from "../../util/Helper.js";
import AuthContext from "../../components/Auth/Auth-context";
//import config from "../../config";
import axios from "axios";
let flag=""

function getStoredUserProfile() {
  const profileData = localStorage.getItem("userProfile");
  if (!profileData || profileData === "undefined") return null;
  try {
    return JSON.parse(profileData);
  } catch (e) {
    return null;
  }
}

// let domain ="fixed"
//console.log("domain out", domain)
class Sidebar extends Component {
 static contextType = AuthContext
 constructor(props) {
    super(props);
    this.baseUrl = null;
    this.roleFetchAttempts = 0;
    this.roleFetchTimer = null;
    // this.state = {
    //   userRole: ""
    // };
  }
  state = {
    userRole: "",
    baseUrl: null
  };

  getMenuStateKeys() {
    return Object.keys(this.state).filter((key) => key.endsWith('MenuOpen'));
  }

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({[menuState] : false});
    } else if(this.getMenuStateKeys().length === 0) {
      this.setState({[menuState] : true});
    } else {
      const resetMenus = {};
      this.getMenuStateKeys().forEach((key) => {
        resetMenus[key] = false;
      });
      this.setState({ ...resetMenus, [menuState]: true });
    }
  }
   getIndividualRole = async () => {
    const userProfile = getStoredUserProfile();
    const userMail = userProfile?.email || "";
    const userFirstName = userProfile?.firstName || "";
    const userLastName = userProfile?.lastName || "";

    if (!userMail) {
      if (this.roleFetchAttempts < 5) {
        this.roleFetchAttempts += 1;
        this.roleFetchTimer = setTimeout(() => this.getIndividualRole(), 400);
      }
      return "";
    }

    this.roleFetchAttempts = 0;
    // const individualRolesUrl = `${config.favApi}dc/datacatalog/getuserRole/${userMail}/${userFirstName}${userLastName}`;
    const individualRolesUrl = `${this.context.baseUrl}dc/datacatalog/getuserRole/${userMail}/${userFirstName}${userLastName}`;

    const response = await axios.get(individualRolesUrl, {
      headers: {
        "X-Country-Code": `${getCountryCode()}`,
      },
      params: { date: Date.now() }
    });
    flag=response?.data?.data?.ROLE
     this.setState({userRole: response?.data?.data?.ROLE})
    return flag;
  };

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    // eslint-disable-next-line no-unused-expressions
    this.getIndividualRole()
    this.setState({ baseUrl: this.context.baseUrl });
    // domain  = window.location.href.toLowerCase().includes("dashboard") ? "": "fixed"
    //console.log("domain in", domain)
    const userProfile = getStoredUserProfile();
    const userMail = userProfile?.email || "";
    const userFirstName = userProfile?.firstName || "";
    const userLastName = userProfile?.lastName || "";

    if (!userMail) {
      if (this.roleFetchAttempts < 5) {
        this.roleFetchAttempts += 1;
        this.roleFetchTimer = setTimeout(() => this.getIndividualRole(), 400);
      }
      return "";
    }

    this.roleFetchAttempts = 0;
    // const individualRolesUrl = `${config.favApi}dc/datacatalog/getuserRole/${userMail}/${userFirstName}${userLastName}`;
    const individualRolesUrl = `${this.context.baseUrl}dc/datacatalog/getuserRole/${userMail}/${userFirstName}${userLastName}`;
    const response =  axios.get(individualRolesUrl, {
      headers: {
        "X-Country-Code": `${getCountryCode()}`,
      },
      params: { date: Date.now() }
    });
    flag=response?.data?.data?.ROLE
     this.setState({userRole: response?.data?.data?.ROLE})
    
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    body.classList.add('sidebar-fixed');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      
      el.addEventListener('mouseover', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

  componentWillUnmount() {
    document.querySelector('body')?.classList.remove('sidebar-fixed');
    if (this.roleFetchTimer) {
      clearTimeout(this.roleFetchTimer);
    }
  }

  componentDidUpdate(prevProps) {
    
    // Update baseUrl if context changes
    if (this.context.baseUrl !== this.state.baseUrl) {
      this.setState({ baseUrl: this.context.baseUrl });
    }
    console.log("baseurl",this.state.baseUrl)
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    const resetMenus = {};
    this.getMenuStateKeys().forEach((key) => {
      resetMenus[key] = false;
    });
    if (Object.keys(resetMenus).length > 0) {
      this.setState(resetMenus);
    }

    const dropdownPaths = [
      {path:'/apps', state: 'appsMenuOpen'},
      {path:'/advanced-ui', state: 'advancedUiMenuOpen'},
      {path:'/form-elements', state: 'formElementsMenuOpen'},
      {path:'/tables', state: 'tablesMenuOpen'},
      {path:'/maps', state: 'mapsMenuOpen'},
      {path:'/icons', state: 'iconsMenuOpen'},
      {path:'/charts', state: 'chartsMenuOpen'},
      {path:'/user-pages', state: 'userPagesMenuOpen'},
      {path:'/error-pages', state: 'errorPagesMenuOpen'},
      {path:'/general-pages', state: 'generalPagesMenuOpen'},
      {path:'/ecommerce', state: 'ecommercePagesMenuOpen'},
    ];

    dropdownPaths.forEach((obj => {
      if (this.isPathActive(obj.path)) {
        this.setState({[obj.state] : true})
      }
    }));
 
  }

  render () { 
    // let positionChange = window.location.href.includes("dashboard") ? "" : "fixed"
    console.log("baseurl inside", this.state.baseUrl)
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          <li className={ this.isPathActive('/Dashboard') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/Dashboard">
            <HomeIcon aria-hidden="true" style={{fontSize: "1.5rem"}}/>
              <span className="menu-title"><Trans>{"\u00A0\u00A0\u00A0"}Home</Trans></span>
            </Link>
          </li>
          <li className={ this.isPathActive('/GlobalAttributes') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/GlobalAttributes">
            <LanguageIcon aria-hidden="true" style={{fontSize: "1.5rem"}}/>
              <span className="menu-title"><Trans>{"\u00A0\u00A0\u00A0"}Global Context</Trans></span>
            </Link>
          </li>
          <li className={ this.isPathActive('/MarketAttributes') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/MarketAttributes">        
              <SouthAmericaIcon aria-hidden="true" style={{fontSize: "1.5rem"}}/>
              <span className="menu-title"><Trans>{"\u00A0\u00A0\u00A0"}Market Context</Trans></span>
            </Link>
          </li>
          <li className={ this.isPathActive('/LOVs') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/LOVs">
            <ListAltIcon aria-hidden="true" style={{fontSize: "1.5rem"}}/>
              <span className="menu-title"><Trans>{"\u00A0\u00A0\u00A0\u00A0"}List Of Values (LOVs)</Trans></span>
            </Link>

          </li>
          <li className={ this.isPathActive('/Taxonomy') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/Taxonomy">        
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-boxes w-5 h-5 flex-shrink-0 text-sidebar-foreground"><path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"></path><path d="m7 16.5-4.74-2.85"></path><path d="m7 16.5 5-3"></path><path d="M7 16.5v5.17"></path><path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"></path><path d="m17 16.5-5-3"></path><path d="m17 16.5 4.74-2.85"></path><path d="M17 16.5v5.17"></path><path d="M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"></path><path d="M12 8 7.26 5.15"></path><path d="m12 8 4.74-2.85"></path><path d="M12 13.5V8"></path></svg>              <span className="menu-title"><Trans>{"\u00A0\u00A0\u00A0"}Brand - Sub Brand</Trans></span>
            </Link>
          </li>
          <li className={ this.isPathActive('/my-change-requests') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/my-change-requests">        
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard-list w-5 h-5 flex-shrink-0 text-sidebar-foreground"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><path d="M12 11h4"></path><path d="M12 16h4"></path><path d="M8 11h.01"></path><path d="M8 16h.01"></path></svg>
              <span className="menu-title"><Trans>{"\u00A0\u00A0\u00A0"}My Change Requests</Trans></span>
            </Link>
          </li>
          {
          this.state.userRole === "Admin"  ?
          <>
          <li className={ this.isPathActive('/change-request-management') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/change-request-management">        
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check w-5 h-5 flex-shrink-0 text-sidebar-foreground"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path><path d="m9 12 2 2 4-4"></path></svg>
              <span className="menu-title"><Trans>{"\u00A0\u00A0\u00A0"}Admin Dashboard</Trans></span>
            </Link>
          </li>

         <li className={ this.isPathActive('/error-pages') ? 'nav-item active' : 'nav-item' }>
            <div className={ this.state.errorPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('errorPagesMenuOpen') } data-toggle="collapse">
            <SettingsIcon aria-hidden="true" style={{fontSize: "1.5rem"}} />
              <span className="menu-title"><Trans>{"\u00A0\u00A0\u00A0"}Settings</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={ this.state.errorPagesMenuOpen }>
              <ul className="nav flex-column sub-menu"> 
                {/* <li className="nav-item"> <Link className="nav-link" to= '/Settings/Administration' ><Trans>Administration</Trans></Link></li> */}
                <li className="nav-item"> <Link className="nav-link" to= '/Settings/RolePage' ><Trans>User Roles</Trans></Link></li>
                <li className="nav-item"> <Link className="nav-link" to= '/Settings/UpdateMetadatas' ><Trans>Update Metadatas</Trans></Link></li>
                <li className="nav-item"> <Link className="nav-link" to= '/Settings/DataUpdateLogs' ><Trans>Data Update Logs</Trans></Link></li>
                <li className="nav-item"> <Link className="nav-link" to= '/Settings/DataRefreshLogs' ><Trans>Data Refresh Logs</Trans></Link></li>
                {this.state.baseUrl === this.context.baseUrl ? (
                  <li className="nav-item"> <Link className="nav-link" to= '/Settings/UpdateSample' ><Trans>Update Sample Product</Trans></Link></li>
                ) : null}
              </ul>
            </Collapse>
        </li>
        </>
:
        <li className={ this.isPathActive('/error-pages') ? 'nav-item active' : 'nav-item' } style={{opacity:"30%"}}>
            <div className={ this.state.errorPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('errorPagesMenuOpen') } data-toggle="collapse">
            <SettingsIcon aria-hidden="true" style={{fontSize: "1.5rem"}} />
              <span className="menu-title"   title="This page is active for Admin only." ><Trans>{"\u00A0\u00A0\u00A0"}Settings</Trans></span>
              <i className="menu-arrow"></i>
            </div>
        </li>
  }
        <li className={ this.isPathActive('/icons') ? 'nav-item active' : 'nav-item' } style={{opacity:"30%"}}>
            <div className={ this.state.iconsMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('iconsMenuOpen') } data-toggle="collapse">
            <ConnectWithoutContactIcon aria-hidden="true" style={{fontSize: "1.5rem"}} />
              <span className="menu-title"  title="This page is currently inactive."><Trans>{"\u00A0\u00A0\u00A0"}S2T Mapping</Trans></span>
            </div>
          </li>
        </ul>
      </nav>
    );
  }


}

export default withRouter(Sidebar);
